import React from 'react'
import TaxYearSelector from '../../../components/TaxYearSelector'
import StudentLoanInputs from '../../../components/StudentLoanInputs'
import { useWizardStore } from '../store'
import VideoWalkthrough from '../../../components/VideoWalkthrough'

export default function StepPersonal() {
  const selectedTaxYear = useWizardStore((s) => s.selectedTaxYear)
  const setSelectedTaxYear = useWizardStore((s) => s.setSelectedTaxYear)
  const inputs = useWizardStore((s) => s.inputs)
  const setInputs = useWizardStore((s) => s.setInputs)

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <h2 className="text-xl font-semibold">Your Tax Profile</h2>
        <p className="text-sm text-gray-500">Set your tax year, residency and student loan plans.</p>
      </div>

      <div>
        <div className="mb-4">
          <TaxYearSelector
            selectedTaxYear={selectedTaxYear}
            onTaxYearChange={(year) => setSelectedTaxYear(year)}
          />
        </div>

        <label className="inline-flex items-center gap-2 mt-2">
          <input
            type="checkbox"
            checked={inputs.isTaxResidentInScotland}
            onChange={(e) => setInputs({ isTaxResidentInScotland: e.target.checked })}
          />
          <span>Tick if you're a Tax resident of Scotland</span>
        </label>
      </div>

      <div>
        <StudentLoanInputs
          selectedPlans={inputs.studentLoanPlans}
          onChange={(plans) => setInputs({ studentLoanPlans: plans })}
          selectedTaxYear={selectedTaxYear}
        />
      </div>

      <div className="space-y-2">
        <h3 className="text-lg font-medium">Watch a quick walkthrough</h3>
        <VideoWalkthrough
          videoId="c48QGzDKbYM"
          title="Calculator walkthrough"
        />
      </div>
    </div>
  )
} 